import React from 'react';
import { useOrderManagement, useOrderActions, useConfirm } from '../hooks';
import { OrderManagementLayout } from '../components/orders';

const OrderManagement: React.FC = () => {
  const {
    loading,
    error,
    searchTerm,
    statusFilter,
    selectedOrder,
    isDetailModalOpen,
    selectedOrderIds,
    isAllSelected,
    bulkUpdating,
    setSearchTerm,
    setStatusFilter,
    fetchOrders,
    handleStatusChange,
    handleViewOrder,
    handleDeleteOrder,
    closeDetailModal,
    toggleOrderSelection,
    toggleAllSelection,
    clearSelection,
    handleBulkStatusChange,
    handleBulkDelete,
    filteredOrders,
    orderStats,
  } = useOrderManagement();

  const { confirm, ConfirmComponent } = useConfirm();

  const { onDeleteOrder, onViewOrder, onStatusChange, onBulkStatusChange, onBulkDelete } =
    useOrderActions({
      handleDeleteOrder,
      handleViewOrder,
      handleStatusChange,
      handleBulkStatusChange,
      handleBulkDelete,
      selectedOrderIds,
      confirm,
    });

  return (
    <OrderManagementLayout
      // Data
      filteredOrders={filteredOrders}
      orderStats={orderStats}
      selectedOrderIds={selectedOrderIds}
      isAllSelected={isAllSelected}
      bulkUpdating={bulkUpdating}
      loading={loading}
      error={error}
      // Filters
      searchTerm={searchTerm}
      statusFilter={statusFilter}
      // Modal
      isDetailModalOpen={isDetailModalOpen}
      selectedOrder={selectedOrder}
      // Handlers
      onSearchChange={setSearchTerm}
      onStatusFilterChange={setStatusFilter}
      onBulkStatusChange={onBulkStatusChange}
      onBulkDelete={onBulkDelete}
      onClearSelection={clearSelection}
      onToggleOrder={toggleOrderSelection}
      onToggleAll={toggleAllSelection}
      onViewOrder={onViewOrder}
      onDeleteOrder={onDeleteOrder}
      onStatusChange={onStatusChange}
      onCloseDetailModal={closeDetailModal}
      onRetry={fetchOrders}
      // Confirm Component
      ConfirmComponent={ConfirmComponent}
    />
  );
};

export default OrderManagement;
